import React from 'react';
import {
  Box, Divider, Typography,
} from '@mui/material';

type BankAccountProps = {
    title?: string,
    bankAccount:{
        accountNumber: string,
        accountType: string,
        bankName: string,
        idNumber: string,
        name: string
    }
}

export default function BankAccount(props: BankAccountProps) {
  const {
    bankAccount,
    title,
  } = props;

  const bankAccountDetails = [
    {
      id: 1,
      label: 'RUT',
      value: bankAccount.idNumber,
    },
    {
      id: 2,
      label: 'Nombre',
      value: bankAccount.name,
    },
    {
      id: 3,
      label: 'Banco',
      value: bankAccount.bankName,
    },
    {
      id: 4,
      label: 'N° de cuenta',
      value: bankAccount.accountNumber,
    },
    {
      id: 5,
      label: 'Tipo de cuenta',
      value: bankAccount.accountType,
    },

  ];
  return (
    <Box width="100%">
      {title && (
      <Typography variant="body1" align="center" fontWeight="bold" marginTop={2} marginBottom={5}>
          {title}
      </Typography>
      )}
      <Box sx={{ width: { md: '100%' }, placeSelf: { xs: 'normal', md: 'center' } }}>
        {bankAccountDetails.map((details, index) => (
          <div>
            <div
              key={details.id}
              style={{
                display: 'flex', placeContent: 'space-between', alignItems: 'center', height: '30px',
              }}
            >
              <Typography textAlign="left" variant="body2" color="textSecondary" width={{ xs: '45%', sm: '50%' }}>
                {details.label}
              </Typography>
              <Typography width="100%" textAlign="right">
                {details.value}
              </Typography>
            </div>
            {index !== bankAccountDetails.length - 1 && (
              <Divider style={{ marginBlock: '5px' }} />
            )}
          </div>
        ))}
      </Box>
    </Box>
  );
}

BankAccount.defaultProps = {
  title: undefined,
};
